import { DynamicFormComponent } from './dynamic-form.component';
import { FormItemComponent } from './components/form-item/form-item.component';
import { FormHandlerService } from './services/form-handler.service';
import { SearchService } from './services/search.service';
import { SuggestionsTemplateComponent } from './components/suggestions-template/suggestions-template.component';
import { WidgetItemComponent } from '@ispm/dynamic-form/components/widget-item/widget-item.component';
import { TabUtility } from '@ispm/dynamic-form/classes/tab-utility.class';
import { RestrictInputLengthDirective } from './directive/restrict-input.directive';
import { FormulaService } from '@ispm/shared/services/formula.service';
import {
  SummaryTableWebService
} from "@ispm/dynamic-form/components/summary-table/summary-table.service";

export const dynamicFormComponents = [
  DynamicFormComponent,
  FormItemComponent,
  SuggestionsTemplateComponent,
  WidgetItemComponent,
  RestrictInputLengthDirective
];

export const dynamicFormServices = [
  FormHandlerService,
  SearchService,
  TabUtility,
  FormulaService,
  SummaryTableWebService
];

export const dynamicFormValidators = [
];
